<template>
  <Breadcrumbs
      title="Gate Pass Out"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Gate Pass Out', path: '/gate-pass' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <getPassTable />
    </div>
  </div>
</template>

<script>
import getPassTable from "@/pages/stock/gate_pass/getPassTable.vue";

export default {
  name: 'indexList',
  components: {
    getPassTable,

  },


}

</script>
